export const TRIP_ACTIVE_LOADING = "tripActive/loading";
export const TRIP_ACTIVE_ERROR = "tripActive/error";
export const TRIP_ACTIVE_FILTERS = "tripActive/filters";
export const TRIP_ACTIVE_LIST = "tripActive/list";
export const TRIP_ACTIVE_ADD = "tripActive/add";
export const TRIP_ACTIVE_UPDATE = "tripActive/update";
export const TRIP_ACTIVE_DELETE = "tripActive/delete";
export const TRIP_ACTIVE_FINISH = "tripActive/finish";



// WEBPACK FOOTER //
// ./src/actions/trip-active/constants.js